import React from 'react';
import styles from './Callout.module.css';

interface CalloutProps {
  type: 'tip' | 'warning' | 'info' | 'note';
  children: React.ReactNode;
}

const ICON_MAP: Record<CalloutProps['type'], string> = {
  tip: '💡',
  warning: '⚠️',
  info: 'ℹ️',
  note: '📝',
};

export const Callout: React.FC<CalloutProps> = ({ type, children }) => (
  <div
    className={`${styles.callout} ${styles[type]}`}
    role="note"
    aria-label={`הערה: ${type}`}
  >
    <span className={styles.icon} aria-hidden="true">
      {ICON_MAP[type]}
    </span>
    <div className={styles.content}>{children}</div>
  </div>
);
